import React, { Component, PropTypes } from 'react';

import OddsButton from 'SharedComponents/OddsButton/OddsButton';

import allCapsToPascalCase from 'SharedComponents/allCapsToPascalCase';

import prefixClassNames from 'SharedComponents/prefixClassNames';
import filterProps from 'SharedComponents/filterProps';
import classNames from 'classnames';
import './OddsBanner.less';

import { moment } from 'OMFECore/vendors';

/** Presentation Component for OMFEOddsBanner */
@prefixClassNames()
export default class OddsBanner extends Component {

    static propTypes = {
        /** Convenience option to quickly apply a background image (stretched) */
        backgroundImage: PropTypes.string,

        /** Pre-configured styling */
        layout: PropTypes.oneOf(['card', 'row', 'tworows']),

        /** Function to format event start date, when event is pending;
         * will receive a UNIX timestamp, the timezone, and an underlying moment object;
         * should return a string with formatted date
         */
        dateFormat: PropTypes.func,

        /** Timezone to display dates in  */
        timezone: PropTypes.string,

        /** Odds format to use - not implemented */
        oddsFormat: PropTypes.string,

        /** Function to call when an odds button is clicked; will receive the underlying odds and match objects */
        onOddsClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        /** Function to call when event title is clicked; will receive the underlying match object */
        onTitleClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        /** Function to call when backgroun is clicked; will receive the underlying match object */
        onBackgroundClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        /** Function to call when match sport is clicked; will receive the underlying match object */
        onSportClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        /** Function to call when match venue is clicked; will receive the underlying match object */
        onVenueClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        /** Function to call when match tournament is clicked; will receive the underlying match object */
        onTournamentClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        matchId: PropTypes.any,
        match: PropTypes.any,
        score: PropTypes.any,
        minute: PropTypes.any,
        status: PropTypes.any,
        odds: PropTypes.any,
        isLoading: PropTypes.bool,

        style: PropTypes.any,
        className: PropTypes.string,
    }

    static defaultProps = {
        layout: 'card',

        onOddsClick: false,
        onTitleClick: false,
        onBackgroundClick: false,
        onSportClick: false,
        onVenueClick: false,
        onTournamentClick: false,

        dateFormat: (ts, tz, m) => ts && m.tz(ts, tz).format('DD/MM HH:mm z') || '',
    }

    oddsClick(e, odds, match){
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        typeof this.props.onOddsClick === 'function' && this.props.onOddsClick(e, odds, match);
    }

    titleClick(e, match){
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        typeof this.props.onTitleClick === 'function' && this.props.onTitleClick(e, match);
    }

    backgroundClick(e, match, backgroundUrl){
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        if (typeof backgroundUrl !== 'undefined' && backgroundUrl != null && (backgroundUrl.indexOf('http') > -1 || backgroundUrl.indexOf('www') > -1)){
            if (typeof this.props.onBackgroundClick === 'function'){
                this.props.onBackgroundClick(e, match, backgroundUrl);
            } else {
                let a = document.createElement('a');
                a.href = backgroundUrl;
                a.target = '_blank';
                document.body.appendChild(a);
                if (typeof a.click === 'function'){
                    a.click();
                } else if (typeof a.onclick === 'function'){
                    a.onclick();
                }
            }
        } else {
            return this.titleClick(e, match);
        }
    }

    sportClick(e, match){
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        typeof this.props.onSportClick === 'function' && this.props.onSportClick(e, match);
    }

    venueClick(e, match){
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        typeof this.props.onVenueClick === 'function' && this.props.onVenueClick(e, match);
    }

    tournamentClick(e, match){
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        typeof this.props.onTournamentClick === 'function' && this.props.onTournamentClick(e, match);
    }

    render(){
        const {
            matchId, match, score, minute, status, odds, isLoading,
            className,
            layout, backgroundImage, backgroundUrl,
            onOddsClick, onTitleClick, onBackgroundClick,
            onSportClick, onTournamentClick, onVenueClick,
            dateFormat, timezone,
            style,
            ...restProps,
        } = this.props;

        const homeParticipantId = match && match.homeParticipantId || false;
        const awayParticipantId = match && match.awayParticipantId || false;

        // Odds

        let hasOutcomesEntities = false;

        for (const key of Object.keys(odds)){
            if (odds[key]._type === 'OUTCOME'){
                hasOutcomesEntities = true;
            }
        }

        var computedOdds = {};
        if (hasOutcomesEntities){
            const outcomes = {};
            const bettingOffers = [];
            for (const key of Object.keys(odds)){
                if (odds[key]._type === 'OUTCOME'){
                    outcomes[odds[key].id] = odds[key];
                } else if (odds[key]._type === 'BETTING_OFFER'){
                    bettingOffers.push(odds[key]);
                }
            }

            for (const key of Object.keys(outcomes)){
                var outcome = outcomes[key];
                var bettingOffer = bettingOffers.find(el => el.outcomeId === outcome.id);
                computedOdds[outcome.id] =
                        Object.assign({}, {
                            ...outcome,
                            outcomeName: outcome.translatedName,
                            shortOutcomeName: outcome.shortTranslatedName,
                        }, bettingOffer);
            }

        } else {
            computedOdds = odds;
        }


        let sortedOdds = [];
        let foundOne = false;
        for (const key of Object.keys(computedOdds)){
            if (computedOdds[key]){
                if (computedOdds[key].isAvailable){
                    foundOne = true;
                }
                sortedOdds.push(computedOdds[key]);
            }
        }
        if (!foundOne) sortedOdds = [];

        sortedOdds.sort((a, b) =>
                a.paramParticipantId1 === homeParticipantId && -Infinity ||
                b.paramParticipantId1 === homeParticipantId && +Infinity ||
                a.paramParticipantId1 === awayParticipantId && +Infinity ||
                b.paramParticipantId1 === awayParticipantId && -Infinity
        );

        // Scores
        const homeGlobalScore = score.paramParticipantId1 === homeParticipantId ? score.paramFloat1 :
                score.paramParticipantId2 === homeParticipantId ? score.paramFloat2 : undefined;
        const awayGlobalScore = score.paramParticipantId1 === awayParticipantId ? score.paramFloat1 :
                score.paramParticipantId2 === awayParticipantId ? score.paramFloat2 : undefined;

        // @FIXME: APIFIX: rpc #eventStatuses
        const {statusId, homeParticipantName, awayParticipantName, startTime, parentName, sportName, venueName, currentPartName} = match || {};
        const matchStatus = (['NO_STATUS', 'PENDING', 'IN_PROGRESS', 'ENDED', 'INTERRUPTED', 'CANCELED', 'WALKOVER', 'ABANDONED', 'RETIRED'])[statusId];

        const newProps = {
            style: Object.assign({}, style || {}, {
                backgroundImage: backgroundImage && backgroundImage.length && backgroundImage.indexOf('//') !== -1 && `url(${backgroundImage})` || 'none',
            }),
            className: classNames(className, {
                OddsBanner: true,

                // Has Match ID
                HasNoMatch: !matchId,

                // Loading
                Loading: !!matchId && isLoading,

                // Current Layout
                [{
                    card: 'CardLayout',
                    row: 'RowLayout',
                    tworows: 'TwoRowsLayout',
                }[layout]]: true,

                // Match Status
                [matchStatus && matchStatus.length && allCapsToPascalCase(matchStatus) || 'NoStatus']: true,
                [sortedOdds && sortedOdds.length && 'HasOdds' || 'NoOdds']: true,
                [typeof homeGlobalScore !== 'undefined' && typeof awayGlobalScore !== 'undefined' && 'HasScore' || 'NoScore']: true,

                // Background Image
                HasBackgroundImage: backgroundImage && backgroundImage.length && backgroundImage.indexOf('//') !== -1,

                // Handlers
                HasOddsClickHandler: typeof onOddsClick === 'function',
                HasTitleClickHandler: typeof onTitleClick === 'function',
                HasSportClickHandler: typeof onSportClick === 'function',
                HasVenueClickHandler: typeof onVenueClick === 'function',
                HasBackgroundClick: (typeof onBackgroundClick === 'function') || (backgroundUrl && (backgroundUrl.indexOf('http') > -1 || backgroundUrl.indexOf('www') > -1)),
                HasTournamentClickHandler: typeof onTournamentClick === 'function',
            }),
            ...filterProps(restProps, this.constructor.propTypes),
        };

        return (
                <div {...newProps} onClick={(e) => this.backgroundClick(e, match, backgroundUrl)}>
                    <div className="MatchContainer" onClick={(e) => this.titleClick(e, match)}>
                        <div className="Header">
                            <div className="FirstRow" onClick={(e) => this.titleClick(e, match)}>
                            <span className="Breadcrumbs">
                                <div className="LiveTag">Live</div>
                                {' '}
                                {sportName &&
                                <a className="SportName" onClick={(e) => this.sportClick(e, match)}>{sportName}</a>}
                                {sportName && venueName && ' › ' || ''}
                                {venueName &&
                                <a className="VenueName" onClick={(e) => this.venueClick(e, match)}>{venueName}</a>}
                                {(sportName || venueName) && parentName && ' › ' || ''}
                                {parentName && <a className="TournamentName"
                                                  onClick={(e) => this.tournamentClick(e, match)}>{parentName}</a>}
                            </span>
                                <h4 className="ParticipantsTitle" onClick={(e) => this.titleClick(e, match)}>
                                <span className={classNames({
                                    HomeParticipant: true,
                                    [`Participant${homeParticipantId}`]: true
                                })}>
                                    {homeParticipantName || ' '}
                                </span>{' '}
                                    <span className="ParticipantSeparator">{homeParticipantName && awayParticipantName && 'vs' || ''}</span>{' '}
                                    <span className={classNames({
                                        AwayParticipant: true,
                                        [`Participant${awayParticipantId}`]: true
                                    })}>
                                    {awayParticipantName || ' '}
                                </span>
                                </h4>
                            </div>
                            <div className="SecondRow" onClick={(e) => this.titleClick(e, match)}>
                                <div className="EndedMessage">This event has ended</div>
                                <div className="Scores">
                                    <span className="CurrentEventPart">{(status && !isNaN(status.paramEventPartId1) && status.paramEventPartName1) || (currentPartName || '')}</span>
                                    <span className="CurrentMinute">{minute && !isNaN(minute.paramFloat1) && `${minute.paramFloat1}'`}</span>
                                    <span className="HomeScore">{homeGlobalScore || 0}</span>
                                    <span className="ScoreSeparator"> - </span>
                                    <span className="SwaySeparator">{awayGlobalScore || 0}</span>
                                </div>
                                <div className="NoScores">{/* Score Unavailable */}</div>
                                <div className="StartTime">{dateFormat(startTime, timezone, moment)}</div>
                            </div>
                        </div>
                        <ul className="OddsGroup" onClick={(e) => this.titleClick(e, match)}>
                            {sortedOdds.length && sortedOdds.map((singleOdds, index) => (
                                    <li
                                            className={classNames({
                                                SingleOdds: true,
                                                [`Participant${
                                                singleOdds.paramParticipantId1 === homeParticipantId && homeParticipantId ||
                                                singleOdds.paramParticipantId1 === awayParticipantId && awayParticipantId
                                                        }`]: !!singleOdds.paramParticipantId1 === homeParticipantId || singleOdds.paramParticipantId1 === awayParticipantId
                                            })}
                                            key={index}
                                    >
                                        <div className="OddsType">
                                            {singleOdds.paramParticipantId1 === homeParticipantId && '1' ||
                                            singleOdds.paramParticipantId1 === awayParticipantId && '2' || 'X'}
                                        </div>
                                        <div className="OddsParticipant">
                                            {singleOdds.paramParticipantId1 === homeParticipantId && homeParticipantName ||
                                            singleOdds.paramParticipantId1 === awayParticipantId && awayParticipantName || singleOdds.outcomeName}
                                        </div>
                                        <OddsButton
                                                odds={singleOdds}
                                                match={match}
                                                onOddsClick={onOddsClick}
                                        >
                                        </OddsButton>
                                    </li>
                            )) || null}
                        </ul>
                        <div className="NoOddsMessage">{/* No odds available */} {' '}</div>
                    </div>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/OMFEOddsBanner/components/OddsBanner.js